import ReactToPrint from "react-to-print";

const PrintButtons = ({
  componentRef,
  labelsComponentRef,
  summaryData,
  productionDate,
  generateMixerChartTable,
  formatDate,
  getDayOfWeek,
  formatTimeToAMPM,
  SummaryPrintableComponent,
  LabelsPrintableComponent
}) => {
  return (
    <div>
      <ReactToPrint
        trigger={() => <button>Print Summary</button>}
        content={() => componentRef.current}
      />
      <div style={{ display: "none" }}>
        <SummaryPrintableComponent
          ref={componentRef}
          summaryData={summaryData}
          day={getDayOfWeek(productionDate)}
          date={formatDate(productionDate)}
          generateMixerChartTable={generateMixerChartTable}
        />
      </div>{" "}
      <ReactToPrint
        trigger={() => <button>Print 4"x3" Labels</button>}
        content={() => labelsComponentRef.current}
      />
      <div style={{ display: "none" }}>
        <LabelsPrintableComponent
          ref={labelsComponentRef}
          summaryData={summaryData}
          day={getDayOfWeek(productionDate)}
          date={formatDate(productionDate)}
          generateMixerChartTable={generateMixerChartTable}
          formatTimeToAMPM={formatTimeToAMPM}
        />
      </div>
    </div>
  );
};

export default PrintButtons;
